var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        shiftY: 0.3,
        name: _vm.name,
        width: "69.5%",
        height: "auto",
        scrollable: true
      },
      on: { "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "absolute right-0 z-20 pl-4 mt-3 mr-3 transform translate-x-0 md:translate-x-full md:mt-0 md:mr-0"
        },
        [
          _c(
            "button",
            {
              staticClass:
                "flex items-center justify-center w-8 h-8 transition-colors duration-200 bg-white rounded-full hover:text-dark text-gray-2 focus:outline-none focus:shadow-outline",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$modal.hide(_vm.name)
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                [
                  _c("line", {
                    attrs: { x1: "18", y1: "6", x2: "6", y2: "18" }
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "6", y1: "6", x2: "18", y2: "18" }
                  })
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }